import { Component, OnInit } from '@angular/core';
import { DashBoardEstadoFaturamento } from 'src/app/base/domain/dashboard-estado-faturamento.model';
import { DashBoardFaturamento } from 'src/app/base/domain/dashboard-faturamento';
import { DashBoardFaturamentoService } from 'src/app/base/services/dashboard-faturamento.service';
import { Router } from '@angular/router';
import { AppState } from 'src/app/App.state';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { DashBoardFilterOptions } from 'src/app/global/faturamento-dashboard/faturamento-dashboard.component';

@Component({
  selector: 'app-faturamento-nacional-main',
  templateUrl: './faturamento-nacional-main.component.html',
  styleUrls: ['./faturamento-nacional-main.component.css'],
})
export class FaturamentoNacionalMainComponent implements OnInit {

  dashboard: DashBoardFaturamento = new DashBoardFaturamento();

  data = new Date();
  dashboardEstadoList: DashBoardEstadoFaturamento[] = [];


  queryOptions = new QueryOptions({ pageSize: 10 });

  constructor(private service: DashBoardFaturamentoService, private router: Router, public appState: AppState) { }

  ngOnInit(): void {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    this.data = date;
    this.queryOptions.params = {
      dataInicial: date.getTime(),
      dataFinal: date.getTime(),
    };

    this.getDashBoard();
  }

  generateMask(value: number): string {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  onReload(): void {
    this.getDashBoard();
  }

  getDashBoard(): void {
    this.data.setHours(0, 0, 0, 0);
    this.appState.isLoading = true;
    this.service.getDashBoardNacional(this.queryOptions).subscribe((response: DashBoardFaturamento) => {
      this.getDashBoardEstado();
      this.dashboard = response;
    });
  }

  getDashBoardEstado(): void {
    this.service.getDashboardEstadoFaturamentoNacional().subscribe((response: DashBoardEstadoFaturamento[]) => {
      this.dashboardEstadoList = response;
      this.appState.isLoading = false;
    });
  }

  onDisclosure(dashboard: DashBoardEstadoFaturamento): void {
    this.queryOptions.params = {
      ...this.queryOptions.params,
      nomeEstado: dashboard.nomeEstado ? dashboard.nomeEstado : null,
    };

    this.router.navigate(['base/gestao/faturamento/estado-faturamento-nacional/' + dashboard.estadoId], {
      queryParams: this.queryOptions.params,
    });
  }

  onFilter(options: DashBoardFilterOptions): void {
    this.queryOptions.params = {
      postoId: options.postoSelecionado ? options.postoSelecionado.id : null,
      estadoId: options.estadoSelecionado ? options.estadoSelecionado.id : null,
      dataInicial: options.dataInicial ? options.dataInicial.getTime() : null,
      dataFinal: options.dataFinal ? options.dataFinal.getTime() : null,
    };

    this.getDashBoard();
  }

  onDownloadPdf(ev: { dataInicio: Date; dataFim: Date }): void {
    const dataInicial = ev.dataInicio.getTime();
    const dataFinal = ev.dataFim.getTime();

    this.appState.isLoading = true;

    this.service.getRelatorioFaturamentoPdf(dataInicial, dataFinal).subscribe({
      next: (blob) => {
        this.downloadBlob(blob, `relatorio-faturamento_${dataInicial}_a_${dataFinal}.pdf`);
        this.appState.isLoading = false;
      },
      error: (err) => {
        console.error('Erro ao baixar PDF', err);
        this.appState.isLoading = false;
      }
    });
  }

  private toYyyyMmDd(d: Date): string {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }

  private downloadBlob(blob: Blob, fileName: string): void {
    const a = document.createElement('a');
    const objectUrl = URL.createObjectURL(blob);
    a.href = objectUrl;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(objectUrl);
  }
}
